import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Stn_ViewReport = () => {
   useAuthRedirect();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const startYear = 2007;

  const [data, setData] = useState([]);
   const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const canView  = hasPermission("STN Requisition Report", "view");
  const canVehicle = hasPermission("Hire Vehicle Registration", "entry");

   // Fetch branches only once
   useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/bill_approval_list_branch")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);


  useEffect(() => {
    fetchData();
  }, [ selectedYear, selectedMonth, selectedBranch]);

  const fetchData = async () => {
    setLoading(true);
    try {
        console.log("Sending params:", { month: selectedMonth, year: selectedYear, branch: selectedBranch });

      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stn_list", {
        params: {  month: selectedMonth, year: selectedYear, branch: selectedBranch }
      });
      console.log(response);
      

      console.log("API Response:", response.data.purchaseOrderList);
      setData(response.data.purchaseOrderList);
      setFilteredData(response.data.purchaseOrderList);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.stn_purnumber || "").toLowerCase().includes(term) ||
       String(item.stn_dpt || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  
if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">STN Requisition</h2>
          <Time />
        </section>



        {/* Month & Year Selection */}
        <div className="month-year-container">
        <p className="title">Select Branch:</p>

<div className="select-container">
<select 
            value={selectedBranch} 
            onChange={(e) => setSelectedBranch(e.target.value)} 
            required 
            className="custom-select"
          >
            <option value="">Select Branch</option>
            {branches.map((item) => (
              <option key={item.branchMaster_code} value={item.branchMaster_code}>
                {item.branchMaster_name}
              </option>
            ))}
          </select>
</div>


          <p className="title">Select your Month & Year:</p>

          <div className="select-container">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(12).keys()].map(i => (
                <option key={i + 1} value={i + 1}>
                  {(i + 1).toString().padStart(2, "0")}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map(i => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>

          <button
  className="custom-button"
  onClick={() => {
    window.location.href = '/inventory/stnRequisitionReport';
  }}
>
  View All
</button>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by STN No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Requisition No</th>
                <th>Branch</th>
                <th>Date</th>
                <th>Department</th>
                <th>H.O.D</th>
                <th>Indent Ref.</th>
                <th>Head Meterial</th>
                   {canVehicle && (
                      <>
                <th>Vehicle Code</th>
                <th>Vehicle No</th>
                <th>Cumulative</th>
                </>
                   )}
                
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/viewstn_report/${item.stn_purnumber}/${item.stn_branchcode}`}>
                        {item.stn_purnumber}
                      </Link>
                    </td>
                    <td>{item.stn_branchcode}</td>
                    <td>{new Date(item.stn_now).toLocaleDateString()}</td>
                    <td>{item.stn_dpt}</td>
                    <td>{item.stn_hod}</td>
                    <td>{item.stn_inref}</td>
                    <td>{item.stn_headmet}</td>
                                       {canVehicle && (
                      <>
                    <td>{item.stn_vcode}</td>
                    <td>{item.stn_vno}</td>
                    <td>{isNaN(Number(item.stn_cumulative)) ? "0.00" : Number(item.stn_cumulative).toFixed(2)}</td>
                    </>
                                       )}
                    
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Stn_ViewReport;
